import { Controller } from "@hotwired/stimulus"

// A passing thought might rather pass than stay. Once the writer has a few
// words down - and only while the post is still an aphorism's length, a line
// or two - the composer offers a day, if they have not chosen how long it
// lasts. Anything longer was worked at, and is left to last. The offer is
// withdrawn the moment the writer chooses for themselves, and not made again
// on this page. maxWords follows Post::APHORISM_MAX_WORDS.
export default class extends Controller {
  static targets = ["select", "hint"]
  static values = {
    minWords: { type: Number, default: 4 },
    maxWords: { type: Number, default: 24 }
  }

  consider(event) {
    if (this.chosenByHand || this.declined) return
    const words = event.target.value.trim().split(/\s+/).filter(Boolean).length
    const short = words >= this.minWordsValue && words <= this.maxWordsValue
    this.hintTarget.hidden = !(short && this.selectTarget.value === "forever")
  }

  accept() {
    this.selectTarget.value = "day"
    this.hintTarget.hidden = true
    this.chosenByHand = true
  }

  chosen() {
    this.chosenByHand = true
    this.hintTarget.hidden = true
  }
}
